/**
 * Base api path
 *
 * @type {string}
 */
export const apiPath = '/api/v1/';
